export const CONTRACT_ADDRESS = '0x59ed4bc78e909ed4df660f410fd4b87a5f16cbc8';
export const ZENSPORTSIA_APP_NAME = 'ZenSportsia';
export const ZENSPORTSIA_WEB3_URL = 'https://mainnet.infura.io/v3/';
export const NetworkContextName = null;
export const supportedChainIds = [
  1,
];
